import {Component, Input, OnInit} from "@angular/core";
import {PortalService} from "./services/portal.service";

/**
 * The advisor image component as image tag for all images that have a neutral version in the application.
 * It works to color some parts of the image in the primary color of the individual portal.
 */

@Component({
    selector: 'app-advisor-image',
    templateUrl: './advisor.image.component.html',
    standalone: false
})

export class AdvisorImageComponent implements OnInit {

  /**
   * image path
   */
  @Input() path: string;

  /**
   * text for alt text
   */
  @Input() altText: string = '';

  /**
   * long description of image for screen readers
   */
  @Input() ariaDescription?: string;

  /**
   * current portalId
   */
  portalId: string;

  /**
   * set to true if the image failed to load, hides the image
   */
  hasError: boolean = false;


  /**
   * constructor
   */
  constructor(public portalService: PortalService) {
    this.portalService.portalHasChanged.subscribe(portalId => {this.portalId = portalId});
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.portalId = this.portalService.currentPortalId;
  }

  /**
   * called when the image fails to load
   */
  onError() {
    this.hasError = true;
  }

}
